import { CreatedInstallments } from "./payment.type";

// TODO: Padronizar esses nomes quanto ao idioma e ao case (upper or lower)
export enum RENTER_STATUS {
  Indefinido = "indefinido",
  Incompleto = "incompleto",
  Bloqueado = "bloqueado",
  ProntoParaAprovacao = "pronto_para_aprovacao",
  PendentePagamento = "pendente_pagamento",
  Ativo = "ativo",
  ReservaPaga = "reserva_paga",
  ReservaPendentePagamento = "reserva_pendente_pagamento",
  Finished = "finished",
  Recision = "recision",
  Recall = "recolhimento",
  WaitingRescision = "aguardando_rescisao",
  Congelado = "congelado",
  Blacklist = "blacklist",
}

export type Address = {
  zipcode: string;
  street: string;
  number?: string | number;
  complement?: string;
  city: string;
  state: string;
  district: string;
  latitude?: number; // Geolocalização, opcional
  longitude?: number; // Geolocalização, opcional
};

export type RenterDocuments = {
  type: string;
  content: string;
  file?: unknown;
  verified: boolean;
};

export type RenterReference = {
  name: string;
  content: string;
  verified: boolean;
};

export type CriminalCheck = {
  jus: boolean;
  escavador: boolean;
};

export type Observation = {
  text: string;
  date: string;
  author: string;
  currentPath: string;
};

type DesactivationDataType = {
  vehicleHistory?: {
    id: string;
    licensePlate: string;
    document: string;
    brand: string;
    model: string;
    color: string;
    chassi: string;
    renavam: string;
    fipeCode: string;
    yearModel: string;
    deviceId: string;
    motorNumber: string;
    vehicleHistoryInitial: Date;
    vehicleHistoryEnd: Date;
    optionRepossesion: string;
    changeVehicle?: boolean;
    partnerId?: string;
  }[];
  planHistory: {
    planHistoryInitial: Date;
    planHistoryEnd: Date;
    id?: string;
    label: string;
    rawValue?: number;
    value: number;
    price?: string;
    planType: string;
    deposit: number;
    depositInstallments: number;
    ilevaId?: number;
    subscriptionInitialDate?: Date;
    subscriptionEndDate?: Date;
    additions: Addition[];
  }[];
  desactivationData: Date;
};

export type FreezePlanInfo = {
  freezeStartDate: Date; // quando o congelamento começou
  freezeEndDatePlanned: Date; // data prevista para descongelamento
  freezeEndDateActual: Date; // data real de descongelamento (null enquanto ainda estiver congelado)
  freezeDurationDays: number; // total de dias congelados (calculado ou ajustado)
  freezeReason: string; // motivo do congelamento
  freezeStatus: string; // congelamento cancelado antes de iniciar
};

export type IRenter = {
  createdAt: Date;
  lead_id?: string; // ID do lead associado, se aplicável
  _id?: string;
  name: string;
  email: string;
  cnh: string;
  categoryCNH: string;
  cpf: string;
  cpfDoIndicador: string;
  companyId: string;
  whatsapp: string;
  birthDate: string;
  references: RenterReference[];
  criminalCheck: CriminalCheck;
  pendencies: Pendency[];
  documents: RenterDocuments[];
  address: Address;
  gender: string;
  status: RENTER_STATUS;
  maritalStatus: string;
  cnhExpirationDate: string;
  typeSanguine: string;
  activationData: ActivationDataType;
  desactivationData: DesactivationDataType;
  rg: string;
  rg_orgexp: string;
  motherName: string;
  externalReferences: {
    paymentCustomerId?: string;
    velotrackDriverId?: string;
  };
  sequencialCode: number;
  contratoPdfIleva: string[];
  rescisaoPdf: string;
  avatar: string;
  booking: Booking;
  observations: Observation[];
  finishedData: FinishedDataType;
  technicalConsultant: string;
  sdr: string;
  rescisionDaysLeft: number;

  collector?: boolean;
  dataPix?: {
    key: string;
    keytype: string;
  };

  cpfDoIndicadorOptions: {
    indicated: boolean;
    notIndicated: boolean;
  };

  situation: string;
  situationDate: Date;
  additionsService: AdditionsServiceType[];
  contract?: Contract;
  groupName: string;
  jurValidation: {
    status: boolean;
    validated: boolean;
    details?: string;
  };
  createdInstallments: CreatedInstallments[]; // para parcelamentos
  createdInstallments_old?: CreatedInstallments[];
  isBlacklisted?: boolean;
  freezePlanInfo: FreezePlanInfo[]; // informações sobre o congelamento do plano
  proRataCount?: number;
  proRataCount_old?: number[];
};

export const emptyRenter = () =>
({
  _id: "",
  name: "",
  email: "",
  cnh: "",
  categoryCNH: "",
  cpf: "",
  cpfDoIndicador: "",
  companyId: "",
  whatsapp: "",
  isBlacklisted: false,
  createdAt: new Date(),
  birthDate: new Date().toUTCString(),
  references: [],
  criminalCheck: {
    jus: false,
    escavador: false,
  },
  pendencies: [],
  documents: [],
  address: {
    zipcode: "",
    street: "",
    number: 0,
    complement: "",
    city: "",
    state: "",
    district: "",
    latitude: 0,
    longitude: 0,
  },
  gender: "",
  status: RENTER_STATUS.Indefinido,
  maritalStatus: "",
  cnhExpirationDate: new Date().toUTCString(),
  typeSanguine: "",
  activationData: {
    vehicle: {
      id: "",
      licensePlate: "",
      document: "",
      brand: "",
      model: "",
      color: "",
      chassi: "",
      renavam: "",
      fipeCode: "",
      yearModel: "",
      deviceId: "",
      motorNumber: "",
      partnerId: "",
    },
    plan: {
      id: "",
      label: "",
      value: 0,
      planType: "",
      deposit: 0,
      depositInstallments: 0,
      ilevaId: 0,
      subscriptionInitialDate: new Date(),
      subscriptionEndDate: new Date(),
      additions: [],
    },
    activationDate: new Date(),
  },
  desactivationData: {
    vehicleHistory: [
      {
        id: "",
        licensePlate: "",
        document: "",
        brand: "",
        model: "",
        color: "",
        chassi: "",
        renavam: "",
        fipeCode: "",
        yearModel: "",
        deviceId: "",
        motorNumber: "",
        vehicleHistoryInitial: new Date(),
        vehicleHistoryEnd: new Date(),
        partnerId: "",
        optionRepossesion: "",
      },
    ],
    planHistory: [
      {
        planHistoryInitial: new Date(),
        planHistoryEnd: new Date(),
        id: "",
        label: "",
        rawValue: 0,
        value: 0,
        price: "",
        planType: "",
        deposit: 0,
        depositInstallments: 0,
        ilevaId: 0,
        subscriptionInitialDate: new Date(),
        subscriptionEndDate: new Date(),
        additions: [],
      },
    ],
    desactivationData: new Date(),
  },
  rg: "",
  rg_orgexp: "",
  motherName: "",
  externalReferences: {
    paymentCustomerId: "",
    velotrackDriverId: "",
  },
  sequencialCode: 0,
  contratoPdfIleva: [],
  rescisaoPdf: "",
  avatar: "",
  booking: {
    depositValue: 0,
    typePayment: "",
  },
  observations: [],
  finishedData: {
    reason: "",
    finePlanValue: 0,
    fineDetran: [],
    complement: "",
    totalValue: 0,
  },
  technicalConsultant: "",
  sdr: "",
  additionsService: [],
  cpfDoIndicadorOptions: {
    indicated: false,
    notIndicated: false,
  },
  rescisionDaysLeft: 0,
  situation: "",
  situationDate: new Date(),
  groupName: "",
  jurValidation: {
    status: false,
    validated: false,
    details: "",
  },
  createdInstallments: [],
  createdInstallments_old: [],
  proRataCount: 0,
  proRataCount_old: [],
  freezePlanInfo: [],
} as IRenter);

export type RenterType = {
  _id: string;
  name: string;
  pendencies: PendencyType[];
  status: RENTER_STATUS;
  updatedAt: string;
  createdAt: Date;
};

export type PendencyType = {
  key: string;
  message: string;
  entityErrors: [
    {
      message: string;
      path: string[];
    }
  ];
};

type Pendency = {
  key: string;
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityErrors: [any];
};

type Booking = {
  depositValue: number;
  typePayment: string;
};

type Addition = {
  label: string;
  value: string;
  key: string;
};

type ActivationDataType = {
  vehicle: {
    id: string;
    licensePlate: string;
    document: string;
    brand: string;
    model: string;
    color: string;
    chassi: string;
    renavam: string;
    fipeCode: string;
    yearModel: string;
    deviceId: string;
    motorNumber: string;
    partnerId?: string;
    odometerVehicle?: number | string;
  };
  plan: {
    id?: string;
    label: string;
    rawValue?: number;
    value: number;
    price?: string;
    planType: string;
    deposit: number;
    depositInstallments: number;
    ilevaId?: number;
    subscriptionInitialDate?: Date;
    subscriptionEndDate?: Date;
    additions: Addition[];
  };
  activationDate?: Date;
  currentContractStartDate?: Date;
};

type FineDetranType = {
  label: string;
  value: number;
};

type FinishedDataType = {
  reason: string;
  finePlanValue: number;
  fineDetran: FineDetranType[];
  complement: string;
  totalValue: number;
};

export type Signer = {
  token: string;
  sign_url: string;
  status: string;
  name: string;
};

export type SignatureInfo = {
  ok: boolean;
  data: {
    originalFile: string;
    name: string;
    status: string;
    signers: Signer;
  };
};

export type AdditionsServiceType = {
  serviceAction: SERVICE_ACTION;
  typeService: SERVICE_TYPE;
  technicalConsultant: string;
  createdAt: Date;
  reason: string;
};

export enum SERVICE_ACTION {
  ADD = "Adicionou",
  REMOVE = "Removeu",
  UNDEFINED = "Indefinido",
}

export enum SERVICE_TYPE {
  PLUS = "plus",
  UNDEFINED = "indefinido",
}

export enum RECOVERY_REASON {
  UNDEFINED = "Indefinido",
  ACCIDENT = "Acidente",
  DEFAULT = "Inadimplencia",
  VEHICLE_EXCHANGE = "Troca de moto",
  SUSPENDED_LICENSE = "Cnh suspensa",
  CARD_REFUSAL = "Recusa do cartão",
  PLAN_COMPLETION = "Finalizar plano",
  PLAN_CANCELLATION = "Cancelar plano",
  WITHDRAWAL = "Desistencia",
  PLAN_FREEZE = "Congelamento",
}

type Contract = {
  name: string;
  cpf: string;
  birthDate: string;
  rg: string;
  rg_orgexp: string;
  whatsapp: string;
  email: string;
  zipcode: string;
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  complement: string;
  cnh: string;
  licensePlate: string;
  categoryCNH: string;
  customizedPlan: string;
  brand: string;
  model: string;
  year: string;
  odometer: string;
  fuel: string;
  fipeValue: string;
  fipeVehicleCode: string;
  price: string;
  date: string;
  caucao: string;
  months: number;
  devolutionDate: string;
  days: number;
};

export enum FINANCIAL_STATUS {
  EM_DIA = "Em dia",
  AGUARDANDO_NEGATIVACAO = "Aguardando Negativação",
  NEGATIVADO = "Já Negativado",
  PARCIALMENTE_NEGATIVADO = "Parcialmente Negativado",
  INADIMPLENTE = "Inadimplente",
  ADIMPLENTE = "Adimplente",
  INDEFINIDO = "Indefinido",
}
